import { Tooltip } from "@heroui/react";
import { InfoIcon } from "lucide-react";

export function TransactionTypeChip({ type }: { type: "public" | "private" }) {
  const tooltipTitle = type === "public" ? "Public transaction" : "Private transaction";
  const tooltipDescription =
    type === "public"
      ? "Bridge transaction runs publicly, at the time of claiming your tokens on Aztec Network, the transaction will take place privately."
      : "Bridge transaction runs publicly, at the time of claiming your tokens on Aztec Network, the transaction will take place privately."; // TODO: Update this
  const label = type === "public" ? "PUBLIC" : "PRIVATE";
  const labelStyle =
    type === "public"
      ? "text-amber-400 bg-amber-500/20 border-amber-500"
      : "text-[#9EEAE0] bg-[#14DBC033] border-[#14DBC0]";

  return (
    <Tooltip
      content={
        <div className="space-y-2">
          <div className="text-small font-semibold">{tooltipTitle}</div>
          <div className="text-small text-[#ADC0D0]">{tooltipDescription}</div>
        </div>
      }
      classNames={{
        base: "max-w-xs",
        content: "py-4 px-6 bg-[#0C1C25]",
      }}
    >
      <div
        className={`inline-flex items-center gap-2 px-2 py-1 rounded-small border font-semibold text-small ${labelStyle}`}
      >
        {label} <InfoIcon className="size-3.5" />
      </div>
    </Tooltip>
  );
}
